import {Modal} from "bootstrap";

const modalContainer = document.getElementById('confirm-accept-offer-modal')
const acceptBtn = document.getElementById('accept-offer-btn');
if (modalContainer && acceptBtn) {
    acceptBtn.addEventListener('click', () => {
        const modal = new Modal(modalContainer)
        modal.show()
    })
}
